<template>
  <div>
    <top-header :type="6" :placeholder="'设计团队'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem" />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="">
        </div>
        <div class="detail_con">
          <div class="inner m_flex_box flex_vc flex_jz" v-for="(item, index) in list" :key="index">
            <img v-lazy="item.logo" alt="" />
            <div class="left flex_v flex_jz">
              <h3 class="line_comp">{{ item.name }}</h3>
              <p>从业经验：{{ item.popularity }}年</p>
              <!-- <p>擅长风格：{{ item.mc }}</p> -->
              <p class="line_comp2">{{ item.description }}</p>
              <p class="m_flex_box flex_vc line">
                <span class="" @click="clickOn(item.id)">查看详情</span>
                <span class=""
                  @click="clickOn(item.id, item.decorationCompanyName, item.decorationCompanyId, item.name)">预约设计</span>
              </p>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  name: 'team',
  data() {
    return {
      isLoading: false,
      list: [],
      listPage: 1,
      loading: false,
      finished: false,
      value: "",
      timer: null,
      pzshow: false
    };
  },
  components: {
    topHeader
  },
  mounted() {
  },


  methods: {
    clickOn(type, v, h, n) {
      if (!v && !h && !n) {
        this.$router.push({
          path: "/teamDetail",
          query: { id: type }
        });
      } else {
        this.$router.push({
          path: "/fixtures",
          query: {
            name: n,
            companyName: v,
            companyId: h,
          }
        });
      }

    },
    onRefresh() {
      this.listPage = 1;
      this.finished = false;
      this.list = [];
      this.onLoad(1);
    },
    onLoad(type) {
      console.log("2121212")
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$request_again.post('/decoration/user', qs.stringify({
          pageSize: 10,
          pageNo: this.listPage,
        })
        )
          .then(res => {
            if (type) {
              this.isLoading = false;
            }
            if (res.success) {
              this.list = this.list.concat(res.result.records);
              this.loading = false;
              if (res.result.pages > this.listPage) {
                this.listPage += 1;
              } else {
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          });
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'NewsDetail') {
      this.$store.dispatch('saveView', ['NewsMain']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  },
};
</script>
<style lang="less" scoped>
.line_comp {
  font-weight: 900;
  font-size: 0.32rem;
}

.pad_top {
  padding-top: 0.8rem;
}

.tab_con {
  position: fixed;
  background-color: #fff;
  left: 0;
  right: 0;
  top: 0.9rem;
  border-bottom: 1px solid #f5f5f5;
  height: 0.8rem;
  font-size: 0.28rem;
  padding: 0 0.23rem;
  white-space: nowrap;
  overflow: auto;
  z-index: 2;
  display: flex;

  span {
    flex: 1;
    text-align: center;
    position: relative;
    line-height: 0.8rem;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      color: #2f72f5;
      font-weight: 800;

      &:after {
        content: "";
        display: block;
        background-color: #2f72f5;
        width: 0.48rem;
        height: 0.04rem;
        position: absolute;
        left: 50%;
        margin-left: -0.24rem;
        bottom: 0;
      }
    }
  }
}

.info_con {
  width: 7.04rem;
  margin: 0 auto;

  .inner {
    border-bottom: 1px solid #f5f5f5;
    padding: 0.4rem 0;

    .left {
      h4 {
        font-size: 0.32rem;
        font-weight: 800;
        color: #202020;
        margin-bottom: 0.14rem;
        line-height: 0.44rem;
      }

      .nr {
        font-size: 0.26rem;
        color: #666;
        margin: 0rem 0 0.18rem;
        line-height: 0.4rem;
      }

      .bottom_ {
        i {
          background-color: #f4f4f4;
          border-radius: 0.02rem;
          font-size: 0.22rem;
          color: #323232;
          padding: 0.02rem 0.04rem;
          margin-right: 0.18rem;
        }

        span {
          color: #909090;
        }
      }
    }
  }
}

.detail_con {
  width: 7.04rem;
  margin: 0 auto;

  .inner {
    border-bottom: 1px solid #f5f5f5;
    padding: 0.4rem 0;

    .left {
      width: 4.66rem;
      height: 2.68rem;

      h4 {
        height: 0.88rem;
        font-size: 0.28rem;
        color: #202020;
        line-height: 0.44rem;
      }

      p {
        i {
          background-color: #f4f4f4;
          border-radius: 0.02rem;
          font-size: 0.22rem;
          color: #323232;
          padding: 0.02rem 0.04rem;
          margin-right: 0.18rem;
        }

        span {
          color: #909090;
        }
      }

      .line {
        display: flex;

        span {
          margin-right: 0.3rem;
          padding: 0.1rem 0.3rem;
          border-radius: 5px;

          &:first-child {
            color: #2f72f5;
            border: 1px solid #2f72f5;
          }

          &:last-child {
            color: #fff;
            background-color: #2f72f5;
          }
        }
      }
    }

    img {
      width: 2.08rem;
      height: 2.78rem;
      object-fit: cover;
    }
  }


}
</style>